// @flow
import { has } from "../../utils/helpers/objects";

import BaseModel from "../base/BaseModel";
import AttributeCollection from "./AttributeCollection";

import type { ModelOptions } from "../types";

/**
 */
export default class AttributeSetModel extends BaseModel {
  _key: string;
  _attributeCollection: AttributeCollection;

  /**
   */
  constructor(
    key: string = "",
    data: Object = {},
    contributions: Object = {},
    modelOptions?: ModelOptions,
  ) {
    super(data, contributions, modelOptions);

    const attributeContributions = this.contributions.attributes
      ? this.contributions.attributes.filter((contribution) => {
          const [contributionKey] = Object.keys(contribution);
          return has(this.data, contributionKey);
        })
      : [];

    this._attributeCollection = new AttributeCollection(
      this.data,
      attributeContributions,
      { ...modelOptions, isReadonly: true },
    );

    this._key = key;
  }

  /**
   */
  get key(): string {
    return this._key;
  }

  /**
   */
  set key(key: string) {
    this._key = key;
  }

  /**
   */
  get label(): ?string {
    return this.contributions.label;
  }

  /**
   * Retrieve attribute collection
   */
  get attributeCollection(): AttributeCollection {
    return this._attributeCollection;
  }

  /**
   * Set the attributes with a new AttributeCollection
   */
  set attributeCollection(collection: AttributeCollection) {
    this._attributeCollection = collection;
  }

  /**
   */
  createChildAttributeSetModel(
    key: string,
    dataObject: Object,
    index?: number,
  ): AttributeSetModel {
    return new AttributeSetModel(
      index ? `${key}-${index + 1}` : key,
      {
        ...dataObject,
        dynamicschema: this.data.dynamicschema,
      },
      this.contributions.objects[key],
      this.modelOptions,
    );
  }

  /**
   * Retrieve child AttributeSetModels
   */
  getChildAttributeSets(): Array<AttributeSetModel> {
    if (!this.contributions.objects) {
      return [];
    }

    const childAttributeSets = [];
    for (const key of Object.keys(this.contributions.objects)) {
      if (key in this.data) {
        if (Array.isArray(this.data[key])) {
          for (const [i, dataObject] of this.data[key].entries()) {
            childAttributeSets.push(
              this.createChildAttributeSetModel(key, dataObject, i),
            );
          }
        } else {
          childAttributeSets.push(
            this.createChildAttributeSetModel(key, this.data[key]),
          );
        }
      }
    }
    return childAttributeSets;
  }
}
